import {Component, OnInit, ViewChild} from '@angular/core';
import {BaseModalComponent} from "common-shared";
import 'brace';
import 'brace/mode/json';
import 'brace/theme/dawn';
import {JSONEditorPropsOptional, Mode} from "vanilla-jsoneditor";
import {JsonEditorComponent} from "../json-editor/json-editor.component";

@Component({
  selector: 'app-json-editor-modal',
  templateUrl: './json-editor-modal.component.html',
  styles: [  ]
})
export class JsonEditorModalComponent extends BaseModalComponent implements OnInit {
  jsonContent: any;
  json: any;
  title: string;
  hasSaveButtons: boolean = false;
  entityId: string;
  editorOptions: JSONEditorPropsOptional;
  @ViewChild(JsonEditorComponent) editor: JsonEditorComponent;

  ngOnInit(): void {
    this.editorOptions = {
      mode: Mode.tree
    };

    //this.editorOptions.expandAll = true;
    this.tryParseJSON(this.jsonContent);
  }

  tryParseJSON(jsonString) {
    try {
      const o = JSON.parse(jsonString);
      if (o && typeof o === "object") {
        this.json = o;
      }
    } catch (e) {
      console.error(e);
    }
  };

  save(withClose: boolean = true) {
    this.action.next({action: 'save', data: withClose});
  }

  changeJson(event = null) {
    const editorJson = this.editor.getEditor();
    editorJson.validate();
    const errors = editorJson.validateSchema?.errors;
    if (errors && errors.length > 0) {
      console.log("Errors found");
    } else {
      this.jsonContent = this.editor.getText();
    }
  }
}
